<template>
  <section class="hero product-detail-wrapper is-fullheight">
    <PmNavbar />
    <div class="hero-body pt-0">
      <div class="container pt-5">
        <div class="columns is-multiline">
          <div class="column is-8">
            <div class="columns is-multiline is-mobile">
              <div class="column is-12 is-12-touch pt-0">
                <figure class="image">
                  <img :src="selectedImage" :alt="product.name"/>
                </figure>
                <div v-if="product.colors && product.colors.length" class="color-swatches mt-3">
                  <div
                    v-for="color in product.colors"
                    :key="color.id"
                    class="color-swatch"
                    :class="{ 'is-active': selectedColorId === color.id }"
                    @click="selectColor(color)"
                    :title="color.name"
                  >
                    <img :src="color.image" :alt="color.name" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-4 has-text-centered-mobile">
            <p class="product-family font-15"></p>
            <h3 class="product-name mt-4">{{ product.name }}</h3>

            <div v-if="product.resource_type=='Cup'" class="product-price mb-4 mt-2">
              <!--p class="font-15" v-for="(price, idxx) in this.$store.getters.getVolumesDiscount(product.id)" :key="idxx" v-bind:class="{ 'bg-grey': idxx % 2 == 0 }">
                <span>{{price.volume_point}} {{ this.$t("message.pages.pricingPage.eachPieceText1") }}</span>
                {{ this.$t("message.pages.pricingPage.eachPieceText2") }}
                <span v-if="product.resource_type=='Cup'">{{price.price}}€ = {{(price.volume_point * price.price).toFixed(2)}}€</span>
              </p-->
            </div>

            <div v-else-if="product.resource_type=='Plate'" class="product-price mb-4 mt-2">
              <p class="font-15" v-for="(price, idxx) in this.$store.getters.getVolumesDiscount(product.id)" :key="idxx" v-bind:class="{ 'bg-grey': idxx % 2 == 0 }">
                <span>{{price.volume_point}} {{ this.$t("message.pages.pricingPage.eachPieceText1") }}</span> {{ this.$t("message.pages.pricingPage.eachPieceText2") }}
                <span>{{price.price}}€ = {{(price.volume_point * price.price).toFixed(2)}} € alv 0%</span>
                <span>{{price.product_material['material']}}</span>
              </p>
            </div>

            <h3 v-else class="product-price mb-4 mt-2" v-if="product.price != undefined">
              {{ product.price.toFixed(2) }} € alv 0%
            </h3>

            <p class="font-15 mt-5 white-space-pre-line">
              {{product?.description?.fi}}
            </p>

            <button
              v-if="product.resource_type != 'Cup' && product.resource_type != 'CandyBox'"
              class="pyroll-button green-bg font-white mt-5 mb-5 font-15"
              @click="selectProductEditor(product.id, product.resource_type, 'cart', selectedColorId)"
            >
              Tilaa tuote
            </button>

            <button
              v-else
              class="pyroll-button green-bg font-white mt-5 mb-5 font-15"
              @click="$router.push({name: 'DesignMethodPage', params: { productId: product.id }})">
              {{ this.$t("message.pages.landing.addCustomizedProduct") }}
            </button>

            <div class="divider" v-if="product.customizable && product.resource_type!='Cup'"></div>

            <p class="font-15 is-ubuntu mt-5" v-if="product.customizable && product.resource_type!='Cup'" style="font-weight: bold;">Oma painatus</p>
            <p class="font-15 is-ubuntu mt-5" v-if="product.customizable && product.resource_type!='Cup'">
              Haluatko tästä tuotteesta oman näköisen, se onnistuu. Voimme painaa tuotteen haluamallasi tavalla.
              Jätä tietosi, niin asiakaspalvelumme ottaa yhteyttä mahdollisimman pian. Huomioithan, että painatuksissa
              voi olla tuotekohtaisia minimimääriä.
            </p>
            <button class="pyroll-button-rectangle font-15 mt-5 mb-5" @click="selectProductRequestForm(product.id)" v-if="product.customizable && product.resource_type!='Cup'">
              Tilaa suunnittelu
            </button>

          </div>
        </div>
      </div>
    </div>
    <PmFooter />
  </section>
</template>

<script>
import { reactive } from "vue";
import PmNavbar from "../components/PmNavbar";
import PmFooter from "../components/PmFooter";
import bulmaCollapsible from "@creativebulma/bulma-collapsible";
import addProductMixin from "@/mixins/addProduct"
import {mapActions, mapMutations} from "vuex";
import { useHead } from '@vueuse/head'

export default {
  name: "ProductDetailPage",
  components: {
    PmNavbar,
    PmFooter,
  },
  data() {
    return {
      product: reactive({}),
      selectedImage: '',
      selectedColorId: null,
    }
  },
  mixins: [addProductMixin],
  mounted() {
    this.getProducts()
    this.setSpinnerState(false)
    this.initCollapsibleElements()
    this.product = this.$store.getters.getProductBySlug(this.$route.params.productSlug)

    // Set initial image
    if (this.product.colors && this.product.colors.length) {
      this.selectColor(this.product.colors[0])
    } else {
      this.selectedImage = this.product.detail_picture || this.product.thumbnail
    }

    useHead({
      title: `${this.product.name} | Pyroll Kauppa`,
      meta: [
        {
          name: 'description',
          content: `${this.product.name} | Pyroll Kauppa`
        },
        {
          property: 'og:title',
          content: `${this.product.name} | Pyroll Kauppa`
        }
      ]
    })
  },
  methods: {
    ...mapMutations({
      setSpinnerState: 'setSpinnerState',
    }),
    ...mapActions([
      'getProducts',
    ]),
    initCollapsibleElements() {
      const bulmaCollapsibleElement =
        bulmaCollapsible.attach(".is-collapsible");
    },
    selectColor(color) {
      this.selectedColorId = color.id
      this.selectedImage = color.image
    }
  }
};
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;

.product-family {
  color: $pyroll-grey;
}

.white-space-pre {
  white-space: pre;
}

.collapse-header-text {
  color: $pyroll-black !important;
  font-family: helvetica-now-display-xbd;
}

.message-header {
  background-color: #ffffff;
}

.message-body {
  background-color: #ffffff;
}

.product-name {
  line-height: 1;
}

.product-3d-thumbnail img {
  background-color: #f3f2f2;
}

.divider {
  border-bottom: 2px solid $pyroll-grey;
}

.white-space-pre-line {
  white-space: pre-line;
}

.color-swatches {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.color-swatch {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  border: 3px solid transparent;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #aaa;
  }

  &.is-active {
    border-color: $pyroll-green;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>

